module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('top-nav'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('h1', [_vm._v(" D3.js vs Vue.js examples ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41b7bac0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 126
// module chunks = 1